import { render, staticRenderFns } from "./DPostContentPreview.vue?vue&type=template&id=128d2c14&scoped=true&"
import script from "./DPostContentPreview.vue?vue&type=script&lang=js&"
export * from "./DPostContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./DPostContentPreview.vue?vue&type=style&index=0&id=128d2c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128d2c14",
  null
  
)

export default component.exports